import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {LoadingBarRouterModule} from '@ngx-loading-bar/router';
import {LoadingBarModule} from '@ngx-loading-bar/core';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {AppComponent} from './app.component';
import {MainComponent} from './Main/Main.component';
import {AppRoutingModule} from './app-routing.module';
import {WidgetsModule} from './Widgets/Widgets.module';
import {MenuComponent} from './Layouts/Menu/HeaderMenu/HeaderMenu/HeaderMenu.component';
import {HeaderOneComponent} from './Layouts/Header/HeaderOne/HeaderOne.component';
import {TemplateModule} from './Template/Template.module';
import {FooterOneComponent} from './Layouts/Footer/FooterOne/FooterOne.component';
import {FooterMenuComponent} from './Layouts/Menu/FooterMenu/FooterMenu/FooterMenu.component';
import {MenuItems} from './Menu/MenuItems/MenuItems';
import {DropletService} from './Services/Droplet.service';
import {StickyheaderComponent} from './Layouts/Header/StickyHeader/StickyHeader.component';
import {PortalHomeComponent} from './Pages/portal-home/portal-home.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DataportalcmsCoreModule} from './core/core.module';
import {DataportalcmsSharedModule} from './shared/shared.module';
import {NgxWebstorageModule} from 'ngx-webstorage';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {JhiEventManager} from './Services/event-manager.service';
import {AuthInterceptor} from './core/interceptor/auth.interceptor';
import {AuthExpiredInterceptor} from './core/interceptor/auth-expired.interceptor';
import {ErrorHandlerInterceptor} from './core/interceptor/errorhandler.interceptor';
import {NotificationInterceptor} from './core/interceptor/notification.interceptor';
import {JhiAlertService} from './Services/alert.service';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {SidebarModule} from 'primeng/sidebar';
import {NgxGoogleAnalyticsModule} from 'ngx-google-analytics';
import {ScrollTopModule} from 'primeng/scrolltop';
import {ButtonModule} from 'primeng/button';
import {MultiSelectModule} from 'primeng/multiselect';
import {RippleModule} from 'primeng/ripple';
import {ToolbarModule} from 'primeng/toolbar';
import {TooltipModule} from 'primeng/tooltip';
import {ImmutableStateExtension, LoggerExtension, ReduxDevtoolsExtension, StoreModule} from '@mini-rx/signal-store';

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    MenuComponent,
    HeaderOneComponent,
    FooterOneComponent,
    FooterMenuComponent,
    StickyheaderComponent,
    PortalHomeComponent,
  ],
    imports: [
        BrowserModule,
        NgbModule,
        NgxWebstorageModule.forRoot({prefix: 'jhi', separator: '-'}),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        BrowserAnimationsModule,
        AppRoutingModule,
        WidgetsModule,
        TemplateModule,
        HttpClientModule,
        StoreModule.forRoot({
            extensions: [
                // Add extensions here
                new LoggerExtension(),
                new ImmutableStateExtension(),
                new ReduxDevtoolsExtension({
                    name: 'Data Portal Store',
                    maxAge: 25,
                    latency: 1000
                })
            ],
            reducers: {
                // Add feature reducers here
            },
            metaReducers: [
                // Add meta reducers here
            ]
        }),
        LoadingBarRouterModule,
        LoadingBarModule,
        LoadingBarHttpClientModule,
        DataportalcmsCoreModule,
        DataportalcmsSharedModule,
        ReactiveFormsModule,
        SidebarModule,
        ScrollTopModule,
        NgxGoogleAnalyticsModule.forRoot('UA-3814340-10'),
        ButtonModule,
        MultiSelectModule,
        RippleModule,
        ToolbarModule,
        TooltipModule,
        FormsModule
    ],
  providers: [
    MenuItems,
    DropletService,
    JhiEventManager,
    JhiAlertService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationInterceptor,
      multi: true
    }
  ],
  exports: [],
  bootstrap: [AppComponent]
})

export class AppModule {
}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
